module.exports = __webpack_public_path__ + "img/Weapon_23.b74134c6.png";